import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const Navdata = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isApps, setIsApps] = useState<boolean>(false);
  const [isFiles, setIsFiles] = useState<boolean>(false);
  const [isSalaryMaster, setIsSalaryMaster] = useState<boolean>(false);
  const [isLogBook, setIsLogBook] = useState<boolean>(false);
  const [isManagementFile, setIsManagementFile] = useState<boolean>(false);
  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  const [allowedMenus, setAllowedMenus] = useState<string[]>([]);
  const [userRole, setUserRole] = useState<string>("");
  const [currentCompany, setCurrentCompany] = useState<any>(null);

  const [refreshKey, setRefreshKey] = useState<number>(0);

  const loadSessionData = useCallback(() => {
    const role = sessionStorage.getItem("userRole") || "";
    setUserRole(role);

    const storedMenus = sessionStorage.getItem("menu");
    if (storedMenus) {
      try {
        const parsedMenus = JSON.parse(storedMenus);
        setAllowedMenus(Array.isArray(parsedMenus) ? parsedMenus : []);
      } catch (error) {
        setAllowedMenus([]);
      }
    } else {
      setAllowedMenus([]);
    }

    const company = sessionStorage.getItem("currentCompany");
    if (company) {
      try {
        setCurrentCompany(JSON.parse(company));
      } catch (error) {
        setCurrentCompany(null);
      }
    } else {
      setCurrentCompany(null);
    }
  }, []);

  useEffect(() => {
    loadSessionData();
  }, [location.pathname, refreshKey, loadSessionData]);

  useEffect(() => {
    const handleSessionUpdate = () => {
      loadSessionData();
      setRefreshKey((prev) => prev + 1);
    };

    window.addEventListener("sessionUpdated", handleSessionUpdate);
    window.addEventListener("storage", handleSessionUpdate);

    return () => {
      window.removeEventListener("sessionUpdated", handleSessionUpdate);
      window.removeEventListener("storage", handleSessionUpdate);
    };
  }, [loadSessionData]);

  // Check if current path matches any submenu - Keep collapse open or close
  useEffect(() => {
    const path = location.pathname;

    // Properties collapse
    if (path === "/properties-perusahaan" || path === "/menu-aplikasi") {
      setIsApps(true);
    } else {
      setIsApps(false);
    }

    // Gaji collapse
    if (
      path === "/data-gaji" ||
      path === "/data-asuransi" ||
      path === "/data-keuntungan" ||
      path === "/data-potongan"
    ) {
      setIsSalaryMaster(true);
    } else {
      setIsSalaryMaster(false);
    }

    // LogBook collapse
    if (path === "/buku-catatan-barang" || path === "/buku-catatan-kendaraan") {
      setIsLogBook(true);
    } else {
      setIsLogBook(false);
    }

    if (path === "/berkas-perusahaan" || path === "/riwayat-kerja-sama") {
      setIsFiles(true);
    } else {
      setIsFiles(false);
    }

    if (
      path === "/superadmin/berkas-perusahaan" ||
      path === "/superadmin/riwayat-kerja-sama"
    ) {
      setIsManagementFile(true);
    } else {
      setIsManagementFile(false);
    }
  }, [location.pathname]);

  function updateIconSidebar(e: any) {
    if (e && e.target && e.target.getAttribute("sub-items")) {
      const ul: any = document.getElementById("two-column-menu");
      const iconItems: any = ul?.querySelectorAll(".nav-icon.active");
      if (iconItems) {
        let activeIconItems = [...iconItems];
        activeIconItems.forEach((item) => {
          item.classList.remove("active");
          var id = item.getAttribute("sub-items");
          const getID = document.getElementById(id) as HTMLElement;
          if (getID) getID.classList.remove("show");
        });
      }
    }
  }

  const shouldShowMenu = (menuCategory: string): boolean => {
    if (!allowedMenus || allowedMenus.length === 0) {
      return false;
    }
    return allowedMenus.includes(menuCategory);
  };

  const handleBackToSuperadmin = (e: any) => {
    e.preventDefault();

    // Clear session storage
    sessionStorage.removeItem("menu");
    sessionStorage.removeItem("currentCompany");

    // Update state immediately
    setCurrentCompany(null);
    setAllowedMenus([]);

    // Dispatch event
    window.dispatchEvent(new Event("sessionUpdated"));

    // Navigate to superadmin dashboard
    navigate("/superadmin/dashboard");

    // Force reload to ensure clean state
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  const allMenuItems: any = useMemo(() => {
    const items: any[] = [];

    // Superadmin menu when viewing a company
    if (userRole === "superadmin" && currentCompany) {
      items.push(
        {
          label: "Superadmin",
          isHeader: true,
        },
        {
          id: "backToSuperadmin",
          label: "Kembali ke Superadmin",
          icon: "ri-arrow-go-back-line",
          link: "/superadmin/dashboard",
          // badgeName: currentCompany.name,
          // badgeColor: "info",
          click: handleBackToSuperadmin,
        },
      );
    }

    // Pure superadmin menu (no company selected)
    if (userRole === "superadmin" && !currentCompany) {
      items.push(
        {
          label: "Menu",
          isHeader: true,
        },
        {
          id: "switchCompany",
          label: "Dashboard",
          icon: "ri-dashboard-line",
          link: "/superadmin/dashboard",
          click: function (e: any) {
            e.preventDefault();
            setIscurrentState("SwitchCompany");
            navigate("/superadmin/dashboard");
          },
        },
        {
          id: "companyManagement",
          label: "Kelola Perusahaan",
          icon: "ri-building-line",
          link: "/superadmin/perusahaan",
          click: function (e: any) {
            e.preventDefault();
            setIscurrentState("CompanyManagement");
            navigate("/superadmin/perusahaan");
          },
        },
        {
          id: "managementFile",
          label: "Kelola Berkas",
          icon: "ri-folders-line",
          link: "/#",
          click: function (e: any) {
            e.preventDefault();
            setIsManagementFile(!isManagementFile);
            setIscurrentState("ManagementFile");
            updateIconSidebar(e);
          },
          stateVariables: isManagementFile,
          subItems: [
            {
              id: "companyFile",
              label: "Berkas Perusahaan",
              link: "/superadmin/berkas-perusahaan",
              parentId: "managementFile",
            },
            {
              id: "historyCooperation",
              label: "Riwayat Kerja Sama",
              link: "/superadmin/riwayat-kerja-sama",
              parentId: "managementFile",
            },
          ],
        },
        {
          id: "masterNotification",
          label: "Master Notifikasi",
          icon: "ri-notification-2-line",
          link: "/superadmin/notifikasi",
          click: function (e: any) {
            e.preventDefault();
            setIscurrentState("masterNotification");
            navigate("/superadmin/notifikasi");
          },
        },
      );
      return items;
    }

    if (
      userRole !== "superadmin" ||
      (userRole === "superadmin" && currentCompany)
    ) {
      items.push(
        {
          label: "Menu",
          isHeader: true,
        },
        {
          id: "dashboard",
          label: "Dashboards",
          icon: "ri-dashboard-line",
          link: "/dashboard",
          click: function (e: any) {
            e.preventDefault();
            setIscurrentState("Dashboard");
            navigate("/dashboard");
          },
        },
        {
          id: "properties",
          label: "Properties",
          icon: "ri-apps-2-line",
          link: "/#",
          click: function (e: any) {
            e.preventDefault();
            setIsApps(!isApps);
            setIscurrentState("Apps");
            updateIconSidebar(e);
          },
          stateVariables: isApps,
          subItems: [
            {
              id: "companyProperties",
              label: "Properties Perusahaan",
              link: "/properties-perusahaan",
              parentId: "properties",
            },
            {
              id: "menuAplikasi",
              label: "Menu Aplikasi",
              link: "/menu-aplikasi",
              parentId: "properties",
            },
          ],
        },
        {
          label: "Support",
          isHeader: true,
          category: "MAIN_DATA",
        },
        {
          id: "info",
          label: "Info",
          icon: "las la-bullhorn",
          link: "/info",
          category: "MAIN_DATA",
          click: function (e: any) {
            e.preventDefault();
            setIscurrentState("Info");
            navigate("/info");
          },
        },
        {
          id: "notifikasi",
          label: "Notifikasi",
          icon: "ri-notification-4-line",
          link: "/notifikasi",
          category: "MAIN_DATA",
          click: function (e: any) {
            e.preventDefault();
            setIscurrentState("Notifikasi");
            navigate("/notifikasi");
          },
        },
        {
          id: "fileManagement",
          label: "Management Berkas",
          icon: "ri-folders-line",
          link: "/#",
          click: function (e: any) {
            e.preventDefault();
            setIsFiles(!isFiles);
            setIscurrentState("Files");
            updateIconSidebar(e);
          },
          stateVariables: isFiles,
          subItems: [
            {
              id: "companyFile",
              label: "Berkas Perusahaan",
              link: "/berkas-perusahaan",
              parentId: "fileManagement",
            },
            {
              id: "collaborationHistory",
              label: "Riwayat Kerja Sama",
              link: "/riwayat-kerja-sama",
              parentId: "fileManagement",
            },
          ],
        },
        {
          label: "Master Data",
          isHeader: true,
          category: "MAIN_DATA",
        },
        {
          id: "admin",
          label: "Admin",
          icon: "ri-user-2-fill",
          link: "/admin",
          category: "MAIN_DATA",
          click: function (e: any) {
            e.preventDefault();
            setIscurrentState("Admin");
            navigate("/admin");
          },
        },
        {
          id: "karyawan",
          label: "Karyawan",
          icon: "ri-team-line",
          link: "/karyawan",
          category: "MAIN_DATA",
          click: function (e: any) {
            e.preventDefault();
            setIscurrentState("Karyawan");
            navigate("/karyawan");
          },
        },
        {
          id: "shift",
          label: "Shift",
          icon: "ri-timer-2-line",
          link: "/shift",
          category: "MAIN_DATA",
          click: function (e: any) {
            e.preventDefault();
            setIscurrentState("Shift");
            navigate("/shift");
          },
        },
        {
          id: "workLocation",
          label: "Lokasi Kerja",
          icon: "ri-map-pin-line",
          link: "/lokasi-kerja",
          category: "MAIN_DATA",
          click: function (e: any) {
            e.preventDefault();
            setIscurrentState("WorkLocation");
            navigate("/lokasi-kerja");
          },
        },
        {
          id: "patrolLocation",
          label: "Lokasi Aktivitas Pekerjaan",
          icon: "las la-map-signs",
          link: "/lokasi-aktivitas-pekerjaan",
          category: "PATROL_LOCATION",
          click: function (e: any) {
            e.preventDefault();
            setIscurrentState("PatrolLocation");
            navigate("/lokasi-aktivitas-pekerjaan");
          },
        },
        {
          id: "gaji",
          label: "Gaji",
          icon: "ri-coins-line",
          link: "/#",
          category: "PAYROLL",
          click: function (e: any) {
            e.preventDefault();
            setIsSalaryMaster(!isSalaryMaster);
            setIscurrentState("Salary");
            updateIconSidebar(e);
          },
          stateVariables: isSalaryMaster,
          subItems: [
            {
              id: "salaryData",
              label: "Data Gaji",
              link: "/data-gaji",
              parentId: "gaji",
            },
            {
              id: "insuranceData",
              label: "Data Asuransi",
              link: "/data-asuransi",
              parentId: "gaji",
            },
            {
              id: "benefitData",
              label: "Data Keuntungan",
              link: "/data-keuntungan",
              parentId: "gaji",
            },
            {
              id: "deductionData",
              label: "Data Potongan",
              link: "/data-potongan",
              parentId: "gaji",
            },
          ],
        },
        {
          label: "Data",
          isHeader: true,
          category: "ATTENDANCE",
        },
        {
          id: "absen",
          label: "Absensi",
          icon: "las la-calendar",
          link: "/absen",
          category: "ATTENDANCE",
          click: function (e: any) {
            e.preventDefault();
            setIscurrentState("Absen");
            navigate("/absen");
          },
        },
        {
          id: "jobActivities",
          label: "Aktivitas Pekerjaan",
          icon: "las la-calendar-check",
          link: "/aktivitas-pekerjaan",
          category: "PATROL",
          click: function (e: any) {
            e.preventDefault();
            setIscurrentState("JobActivities");
            navigate("/aktivitas-pekerjaan");
          },
        },
        {
          id: "logBook",
          label: "Buku Catatan",
          icon: "ri-book-read-line",
          link: "/#",
          category: "LOG_BOOK",
          click: function (e: any) {
            e.preventDefault();
            setIsLogBook(!isLogBook);
            setIscurrentState("LogBook");
            updateIconSidebar(e);
          },
          stateVariables: isLogBook,
          subItems: [
            {
              id: "itemLog",
              label: "Data Barang",
              link: "/buku-catatan-barang",
              parentId: "logBook",
            },
            {
              id: "vehicleLog",
              label: "Data Kendaraan",
              link: "/buku-catatan-kendaraan",
              parentId: "logBook",
            },
          ],
        },
        {
          id: "event",
          label: "Event",
          icon: "mdi mdi-calendar-month-outline",
          link: "/event",
          category: "EVENT",
          click: function (e: any) {
            e.preventDefault();
            setIscurrentState("Event");
            navigate("/event");
          },
        },
        {
          id: "Lembur",
          label: "Lembur",
          icon: "las la-briefcase",
          link: "/lembur",
          category: "ATTENDANCE",
          click: function (e: any) {
            e.preventDefault();
            setIscurrentState("Lembur");
            navigate("/lembur");
          },
        },
        {
          id: "paySlip",
          label: "Slip Gaji",
          icon: "las la-money-check-alt",
          link: "/slip-gaji",
          category: "PAYROLL",
          click: function (e: any) {
            e.preventDefault();
            setIscurrentState("paySlip");
            navigate("/slip-gaji");
          },
        },
      );
    }

    return items;
  }, [
    isApps,
    isSalaryMaster,
    isLogBook,
    isManagementFile,
    isFiles,
    userRole,
    currentCompany,
    allowedMenus,
    navigate,
  ]);

  const filteredMenuItems = useMemo(() => {
    const filtered = allMenuItems.filter((item: any) => {
      if (!item.category) return true;
      return shouldShowMenu(item.category);
    });

    const result: any[] = [];
    for (let i = 0; i < filtered.length; i++) {
      const item = filtered[i];

      if (item.isHeader) {
        if (i + 1 < filtered.length && !filtered[i + 1].isHeader) {
          result.push(item);
        }
      } else {
        result.push(item);
      }
    }

    return result;
  }, [allMenuItems, allowedMenus]);

  return <React.Fragment>{filteredMenuItems}</React.Fragment>;
};

export default Navdata;
